export default class FlexibleDurationPicker extends HTMLElement {
    #choices: HTMLInputElement[] = [];

    get type(): string {
        const selected = this.#choices.find(
            (input) => input.name === 'flex_duration' && input.checked
        );
        return selected?.value || '';
    }

    get months(): number[] {
        return this.#choices
            .filter((input) => input.name === 'flex_month' && input.checked)
            .map((input) => Number(input.value));
    }

    protected connectedCallback(): void {
        this.#choices = Array.from(this.querySelectorAll('input')) as HTMLInputElement[];

        this.addEventListener('clear', this.#onClear.bind(this));
    }

    protected disconnectedCallback(): void {
        this.removeEventListener('clear', this.#onClear.bind(this));
    }

    #onClear(): void {
        this.#choices.forEach((input) => {
            input.checked = input.id === 'flex_duration_weekend';
        });

        this.dispatchEvent(new Event('change'));
    }
}

if (!customElements.get('nh-flexible-duration-picker')) {
    customElements.define('nh-flexible-duration-picker', FlexibleDurationPicker);
}
